function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "il-a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M0 0h512v512H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#il-a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M619.4 512H-112V0h731.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00c",
  d: "M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275 110.1 191.6L359 191.6l-222.6-.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m225.8 317.8 20.9 35.5 21.4-35.3-42.4-.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00c",
  d: "M136 320.6 246.2 129l112.4 190.8-222.6.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m225.8 191.6 20.9-35.5 21.4 35.4-42.4.1zM182 271.1l-21.7 36 41-.1-19.3-36zm-21.3-66.5 41.2.3-19.8 36.3-21.4-36.6zm151.2 67 20.9 35.5-41.7-.5 20.8-35zm20.5-67-41.2.3 19.8 36.3 21.4-36.6zm-114.3 0L189.7 256l28.8 50.3 52.8 1.2 32-51.5-29.6-52-55.6.5z"
}));

var SvgIl = function SvgIl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-il",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/il.5de4d676.svg";
export { ForwardRef as ReactComponent };